import { generateClient } from "aws-amplify/api";
import { getOverAllPolls } from "@/graphql/queries";
const client = generateClient();
export const GetAllPolls = {
  methods: {
    async GetAllPollsMethod(poll_status) {
      try {
        this.loading = true;
        let result = await client.graphql({
          query: getOverAllPolls,
          variables: {
            input: {
              user_id: this.$store.getters.get_current_user_details.user_id,
              poll_status,
            },
          },
        });
        var ResultObj = JSON.parse(result.data.getOverAllPolls);
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          this.GetAllPollsList = ResultObj.data.items;
        }
        this.loading = false;
      } catch (error) {
        this.GetAllPollsList = [];
        this.loading = false;
        console.log("Error", error);
      }
    },
  },
};
